export default __webpack_public_path__ + "static/media/img7.2d42c58f.png";